import comp from "./GPTConversation";
export default comp;
